<template>
  <v-layout elevation-7>
    <v-flex>
      <v-card v-if="model != null">
        <v-parallax src="/static/images/asianacargo-card.jpg" height="100">
          <v-layout align-center column justify-center>
            <h1 class="display-1 mb-1 s-card-title font-effect-3d-float">아시아나 카고</h1>
            <h4
              style="width:100%; padding-left:10px; padding-right:10px;"
              class="subheading s-card-subtitle text-xs-center"
            >{{ model.baseInfo.latestEventMessage + '(' + model.baseInfo.latestEventDate + ')'}}</h4>
          </v-layout>
        </v-parallax>

        <v-container id="grid" fluid grid-list-sm tag="section">
          <!--<v-flex mb-2>-->
            <!--<span class="title">{{ model.baseInfo.awbNumber }}</span>-->
          <!--</v-flex>-->
          <v-layout wrap>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <label-text title="출발지" :text="model.baseInfo.origin"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <LabelText title="출발지명" :text="model.baseInfo.originName"></LabelText>
              <v-divider></v-divider>
            </v-flex>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <label-text title="도착지" :text="model.baseInfo.destination"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex lg6 md6 sm6 xs6 pl-2 pr-2>
              <label-text title="도착지명" :text="model.baseInfo.destinationName"></label-text>
              <v-divider></v-divider>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>

        <v-container v-if="!hasResult" fill-height fluid>
          <v-layout column class="text-xs-center">
            <v-flex>
              <h1 v-if="!hasResult" class="title">조회된 데이터가 없습니다</h1>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container grid-list-xs>
          <v-flex md5 >
            <span class="title">항공정보</span>
          </v-flex>

          <v-layout text-xs-center child-flex>
            <v-flex xs4 >
              <v-layout fill-height >
              <v-card dark style="width:100%; marginRight:1px;">
                <v-card-text>
                  <span class="subheading">Flight No.</span>
                </v-card-text>
              </v-card>
              </v-layout>
            </v-flex>

            <v-flex xs4>
              <v-layout fill-height >
                <v-card dark style="width:100%; marginRight:1px;">
                <v-card-text>
                  <span class="subheading">Departure Date</span>
                </v-card-text>
              </v-card>
              </v-layout>
            </v-flex>

            <v-flex xs4>
              <v-layout fill-height >
                <v-card dark style="width:100%">
                <v-card-text>
                  <span class="subheading">Arrival Date</span>
                </v-card-text>
              </v-card>
              </v-layout>
            </v-flex>
          </v-layout>

          <template v-for="(item, index) in this.model.bookingList">
            <v-layout text-xs-center child-flex :key="index" >

              <v-flex xs4 >
                <v-layout fill-height>
                  <v-flex>
                    <v-card height="100%">
                      <v-card-text>
                        <span class="subheading">{{ item.flightCarrierCode + item.flightNumber}}</span><div></div>
                        <span class="body-1">{{ item.segmentOrigin + '-' + item.segmentDestination}}</span>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs4 >
                <v-layout fill-height >
                  <v-flex >
                    <v-card height="100%">
                      <v-card-text style="padding:0px;">
                        <div v-if="item.departureTime !== null && item.departureTime !== ''">
                          <v-tooltip left>
                            <v-chip slot="activator" small outline color="primary">STD</v-chip>
                            <span>Scheduled time of departure</span>
                          </v-tooltip>
                          <v-flex hidden-sm-and-up></v-flex>
                          <span class="body-1">{{ item.departureTime }}</span>
                        </div>
                        <div v-if="item.estimatedDepartureDateLeg !== null && item.estimatedDepartureDateLeg !== ''">
                          <v-tooltip left>
                            <v-chip slot="activator" small outline color="green">ETD</v-chip>
                            <span>Estimated time of departure</span>
                          </v-tooltip>
                          <v-flex hidden-sm-and-up></v-flex>
                          <span class="body-1">{{ item.estimatedDepartureDateLeg }}</span>
                        </div>
                        <div v-if="item.actualDepartureDateLeg !== null && item.actualDepartureDateLeg !== ''">
                          <v-tooltip left>
                            <v-chip slot="activator" small outline color="pink">ATD</v-chip>
                            <span>Actual time of departure</span>
                          </v-tooltip>
                          <v-flex hidden-sm-and-up></v-flex>
                          <span class="body-1">{{ item.actualDepartureDateLeg }}</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs4 >
                <v-layout fill-height>
                  <v-flex>
                    <v-card height="100%">
                      <v-card-text style="padding:0px;">
                        <div v-if="item.arrivalDate !== null && item.arrivalDate !== ''">
                          <v-tooltip left>
                            <v-chip slot="activator" small outline color="primary">STA</v-chip>
                            <span>Scheduled time of arrival</span>
                          </v-tooltip>
                          <v-flex hidden-sm-and-up></v-flex>
                          <span class="body-1">{{ item.arrivalDate }}</span>
                        </div>
                        <div v-if="item.estimatedArrivalDateLeg !== null && item.estimatedArrivalDateLeg !== ''">
                          <v-tooltip left>
                            <v-chip slot="activator" small outline color="green">ETA</v-chip>
                            <span>Estimated time of arrival</span>
                          </v-tooltip>
                          <v-flex hidden-sm-and-up></v-flex>
                          <span class="body-1">{{ item.estimatedArrivalDateLeg }}</span>
                        </div>
                        <div v-if="item.actualArrivalDateLeg !== null && item.actualArrivalDateLeg !== ''">
                          <v-tooltip left>
                            <v-chip slot="activator" small outline color="pink">ATA</v-chip>
                            <span>Actual time of arrival</span>
                          </v-tooltip>
                          <v-flex hidden-sm-and-up></v-flex>
                          <span class="body-1">{{ item.actualArrivalDateLeg }}</span>
                        </div>
                      </v-card-text>
                    </v-card>

                  </v-flex>
                </v-layout>
              </v-flex>

              <v-divider v-if="index + 1 < model.bookingList.length" :key="`divider-${index}`"></v-divider>
            </v-layout>
          </template>
        </v-container>
        <!--<v-flex>-->
        <!--<template v-for="(item, index) in this.model.bookingList">-->
        <!--<delivery-list-item v-bind:key="index"-->
        <!--v-bind:title="item.flightNumber"-->
        <!--v-bind:primary-chip="item.flightNumber"-->
        <!--v-bind:green-chip="'신고번호:'+item.flightNumber"-->
        <!--&gt;</delivery-list-item>-->
        <!--<v-divider v-if="index + 1 < model.bookingList.length" :key="`divider-${index}`"></v-divider>-->
        <!--</template>-->
        <!--</v-flex>-->
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
import LabelText from '../LabelText'
import DeliveryListItem from '../DeliveryListItem'

export default {
  name: 'AsaianaCargoCard',
  components: {LabelText, DeliveryListItem},
  props: ['model'],
  data () {
    return {
      dialog2: false,
      showTooltip: false
    }
  },
  computed: {
    hasResult: function () {
      // return false
      return this.model.bookingList.length > 0
    }
  },
  methods: {
    clickLabel: function (type) {
      this.showTooltip = !this.showTooltip
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/card/AsianaCargoCard.vue